<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import {
  apiRushToken
} from './plugins/apis'
export default {
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
      setInterval(async ()=>{
        if(window.localStorage.cima_registration_token){
          // await this.rushToken()
        }
      },5000*1000)
  },
  methods: {
      async rushToken(){
        let res = await apiRushToken()
        if(res.code === 200){
          window.localStorage.setItem('cima_registration_token',res.data.token)
        }
      }
  }
};
</script> 